<template>
  <b-col
    v-if="render && canViewThisAction('read', 'InventoryRequest')"
    class="d-inline"
    lg="6"
  >
    <b-card
      class="overview-card-height"
    >
      <b-card-title class="mb-1 fs-21 pure-black">
        Inventory Requests
      </b-card-title>
      <b-card-sub-title class="mb-2 black-color fs-16">
        {{ yearOption }}: Open Status ({{ irCount }})
      </b-card-sub-title>

      <vue-apex-charts
        type="donut"
        height="250"
        :options="chartOptions"
        :series="dataSeries"
      />
    </b-card>
  </b-col>
</template>

<script>
import {
  BCard, BCardTitle, BCardSubTitle, BCol,
} from 'bootstrap-vue'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useAclUtils } from '@/libs/acl/custom'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    VueApexCharts,
    BCard,
    BCardTitle,
    BCardSubTitle,
    BCol,
  },
  props: {
    yearOption: {
      type: [Number, null],
      default: moment().format('YYYY'),
    },
    storeOptions: {
      type: [Array, null],
      default: () => [],
    },
  },
  data() {
    return {
      canViewThisAction,
      render: false,
      irCount: 0,
      dataSeries: [],
      chartOptions: {
        chart: {
          fontFamily: 'Montserrat',
        },
        legend: {
          show: true,
          position: 'right',
          fontSize: '14px',
          fontFamily: 'Montserrat',
          horizontalAlign: 'center',
          itemMargin: {
            horizontal: 0,
            vertical: 5,
          },
          formatter(seriesName, opts) {
            // return [seriesName, ' ', opts.w.globals.series[opts.seriesIndex]]
            return `<span class="legend-item-label black-color">${seriesName}</span> <span class="weight-600 legend-item-value">${opts.w.globals.series[opts.seriesIndex]}</span>`
          },
        },
        colors: [],
        dataLabels: {
          enabled: true,
          formatter(val, { seriesIndex, w }) {
            return w.config.series[seriesIndex]
            // eslint-disable-next-line radix
            // return `${parseInt(val)}%`
          },
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: false,
                name: {
                  fontSize: '2rem',
                  fontFamily: 'Montserrat',
                },
                value: {
                  fontSize: '1rem',
                  fontFamily: 'Montserrat',
                  formatter(val) {
                    // eslint-disable-next-line radix
                    return `${parseInt(val)}`
                  },
                },
                total: {
                  show: false,
                  fontSize: '1.5rem',
                  label: 'Operational',
                  formatter() {
                    return '31%'
                  },
                },
              },
            },
          },
        },
        labels: [],
        responsive: [
          {
            breakpoint: 992,
            options: {
              chart: {
                height: 380,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
          {
            breakpoint: 576,
            options: {
              chart: {
                height: 320,
              },
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      name: {
                        fontSize: '1.5rem',
                      },
                      value: {
                        fontSize: '1rem',
                      },
                      total: {
                        fontSize: '1.5rem',
                      },
                    },
                  },
                },
              },
              legend: {
                show: true,
              },
            },
          },
        ],
      },
    }
  },

  watch: {
    $props: {
      handler() {
        this.render = false
        this.getData()
      },
      deep: true,
      immediate: true,
    },
  },

  beforeMount() {
    this.getData()
  },
  methods: {
    getData() {
      const formData = new FormData()

      formData.append('stores', JSON.stringify(this.storeOptions))
      formData.append('year', this.yearOption)

      this.$http.post('user/inventory/inventory-requests/stores', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          const result = response.data.irData
          let total = 0
          const series = []
          const labels = []
          const colors = []
          const colorOptions = [
            '#104D9D', '#179CA6', '#F2B231', '#F36554', '#383D3B', '#6F5F75', '#9883AB', '#EB212E', '#F7A1A3', '#FF4D80',
            '#85B79D', '#21BB8B', '#9999A1', '#808772', '#51513D', '#A57548', '#CBA5A2', '#8C4843', '#633042', '#57276E',
            '#ACC18A', '#9DC7C8', '#98D2EB', '#119285', '#95D082', '#DFDF2F', '#AB966D', '#D2AD63', '#FF9F43', '#FF5C00',
            '#146ADC', '#150578', '#7BDFF2', '#8FD225', '#BBADA0', '#C099E3', '#FF595E', '#D0520B', '#F27A6B', '#C33C54',
          ]
          result.forEach((element, key) => {
            total += element.totalCount

            series.push(element.totalCount)

            colors.push(colorOptions[key] ? colorOptions[key] : '#104D9D')
            labels.push(element.store.name)
          })

          this.irCount = total
          this.dataSeries = series
          this.chartOptions.labels = labels
          this.chartOptions.colors = colors

          this.render = true
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>
